import { useContext } from 'react';

import { useField } from 'react-final-form';

import { ConditionalWrapper } from '@cast/design-system';

import { TypeNotSupportedWrapper } from '../../../../_components/TypeNotSupportedWrapper';
import { useHideHpa } from '../../../../_hooks/permissions/useHideHpa';
import { WorkloadDetailsContext } from '../../../_context';
import { useHpaDisabledReasons } from '../../_hooks/useHpaDisabledReasons';
import { ExplanationTooltip } from '../ExplanationTooltip';

import { RffSwitch } from '@cast/shared-rff-ui';

export const HpaSwitch = () => {
  const { workload } = useContext(WorkloadDetailsContext);

  const { isDisabled, typeNotSupported, hasNativeHpa } =
    useHpaDisabledReasons(workload);

  const {
    input: { value: isRightsizingEnabled },
    meta: { initial: initialRightsizingEnabled },
  } = useField('horizontalRightsizing.enabled');

  const { hideHpa } = useHideHpa();

  const hasWoopAndNativeHpa = hasNativeHpa && initialRightsizingEnabled;
  // Toggle should be active if both WOOP and native HPA were enabled
  const isToggleDisabled = hasWoopAndNativeHpa ? false : isDisabled;

  if (hideHpa) {
    return null;
  }

  return (
    <ConditionalWrapper
      condition={typeNotSupported}
      wrapper={(child) => (
        <TypeNotSupportedWrapper>{child}</TypeNotSupportedWrapper>
      )}
    >
      <ExplanationTooltip
        readOnlyTooltip="Cannot adjust optimization because the workload is assigned to castware scaling policy"
        disableTooltip={typeNotSupported || hasWoopAndNativeHpa}
        isOnHorizontalPolicy
      >
        <RffSwitch
          name="horizontalRightsizing.enabled"
          onClick={(event) => {
            // When enabling HPA, expand section as input values are required
            if (isRightsizingEnabled) {
              event.stopPropagation();
            }
          }}
          size="md"
          disabled={isToggleDisabled}
          testId="rightsizing-toggle"
        />
      </ExplanationTooltip>
    </ConditionalWrapper>
  );
};
